import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import moment from 'moment';
import XLSX from 'xlsx';
import {
	Form,
	Table,
	Button,
	Input,
	Select,
	Modal,
	DatePicker,
	Menu,
	Dropdown,
	Row,
	Col,
	Divider,
	Image,
	Radio,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	download,
	parseTime,
	formatTime,
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'statusList':{},
			
			'selectedRowKeys':[],
			'list':[],
			'showDialog':false,
			'showPayDialog':false,
			
			'pageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
			
			'orderInfo':{},
			'info':{
				'extra_info':{
					'order_category':[],
				},
				'image_list':[],
			},
		};
	}
	
	componentDidMount()
	{
		let userInfo = CommonValue.get('user_info');
		this.setState({
			'userInfo':userInfo,
		});
		
		this.getStatusList()
		this.getList();
		
		document.title = '商品订单 - ' + CommonValue.get('site_name');
	}
	componentWillUnmount()
	{
		if(this.loop)
			window.clearInterval(this.loop);
	}
	
	getStatusList()
	{
		let url = pcUrl('order','statusList');
		let param = {
			'order_type':1,
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'statusList':data,
				});
			});
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('order','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		param['order_type'] = 1;
		httpPost(url,param)
			.then(data=>{
				data['list'].forEach(row=>{
					row.key = row['order_id'];
				});
				
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
				
			});
	}
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['start_time'] = moment(filter.time[0]).format('YYYY-MM-DD');
			filter['end_time'] = moment(filter.time[1]).format('YYYY-MM-DD');
			delete(filter.time);
		}
		return filter;
	}
	
	export()
	{
		let selection = this.state.selectedRowKeys;
		if(!selection.length)
		{
			if(!+this.state.pageInfo.total)
			{
				message('无可导出数据');
				return false;
			}
			
			confirm('您没有选择要导出的数据，确认导出所有订单吗?')
				.then(()=>{
					let url = pcUrl('order','export');
					let param = this._parseFilter(this.filterForm.getFieldsValue());
					param['order_type'] = 1;
					httpPost(url,param)
						.then(data=>{
							this._export(data);
						});
				});
		}
		else
		{
			
			let url = pcUrl('order','export');
			let param = {
				'order_ids':this.state.selectedRowKeys.join(','),
			};
			param['order_type'] = 1;
			httpPost(url,param)
				.then(data=>{
					this.setState({
						'selectedRowKeys':[],
					});
					this._export(data);
				});
			
			//let selectionRows = this.state.list.filter(row=>this.state.selectedRowKeys.includes(row['order_id']));
			//console.log(selectionRows);
		}
	}
	
	_export(rawData)
	{
		let tableHead = [
			{
				'key':'order_sn',
				'name':'订单编号',
				'group':'order_info',
			},
			{
				'key':'order_amount',
				'name':'订单金额',
				'group':'order_info',
			},
			{
				'key':'order_status',
				'name':'订单状态',
				'group':'order_info',
			},
			{
				'key':'add_time',
				'name':'下单时间',
				'group':'order_info',
			},
			
			
			{
				'key':'reciver_consignee',
				'name':'收货姓名',
				'group':'extra_info',
			},
			{
				'key':'reciver_phone',
				'name':'联系手机',
				'group':'extra_info',
			},
			{
				'key':'reciver_area_info',
				'name':'城市信息',
				'group':'extra_info',
			},
			{
				'key':'reciver_address',
				'name':'收货地址',
				'group':'extra_info',
			},
			
			{
				'key':'goods_name',
				'name':'商品名称',
			},
			{
				'key':'category_name',
				'name':'分类',
			},
			{
				'key':'goods_price',
				'name':'商品价格',
			},
			{
				'key':'quantity',
				'name':'数量',
			},
			{
				'key':'goods_amount',
				'name':'原价',
			},
			{
				'key':'pay_amount',
				'name':'现价',
			},
		];
		
		// 新建空workbook，然后加入worksheet
		/*
		let image = new window.Image();
		image.src = 'http://b2b-print.test.com/uploads/20220622/cbd5d562de7ef3140438406b6c15ad57.jpg';
		*/
		//const ws = XLSX.utils.json_to_sheet(data)
		/*
		data = [
			{
				'姓名':'张三',
				'年龄':20,
				'性别':'男',
			},
			{
				'姓名':'李四',
				'年龄':25,
				'性别':'女',
			},
		];
		data = [
			[
				'姓名',
				'年龄',
				'性别',
			],
			[
				'张三',
				20,
				//'男',
				//'<span class="green">123123</span>'
				'分类名1\n分类名2\n分类名3'
			],
			[
				'李四',
				25,
				'女',
			],
		];
		let wb = {
			SheetNames: ["mySheet"],
			Sheets: {
				mySheet: {
					"!ref":"A1:C1",
					A1: { t:"d", v:"30-Jan-1967" },
					B1: { t:"s", v:"This is some text" },
					C1: { t:"n", v:10000 }
				}
			}
		}
		let ws = {
			"!ref":"A1:C1",
			A1: { t:"d", v:"30-Jan-1967" },
			B1: { t:"s", v:"This is some text", s:{font:{sz:20,color:'red'}} },
			C1: { t:"n", v:10000 }
		};
		*/
		
		//组装数据
		let data = [];
		data.push(tableHead.map(row=>row.name));
		
		rawData.forEach((row,index)=>{
			let newRow = [];
			
			tableHead.forEach(row1=>{
				let key = row1.key;
				let name = row1.name;
				let group = row1.group;
				let value = '';
				if(group)
				{
					value = row[group][key];
				}
				else
					value = row[key];
				
				//数据处理
				//订单状态
				if('order_status' == key)
				{
					value = row[group]['order_status_exp'];
				}
				//下单时间
				else if('add_time' == key)
				{
					value = parseTime(value);
				}
				
				//单价
				else if(
					'order_amount' == key ||
					'goods_price' == key ||
					'goods_amount' == key ||
					'pay_amount' == key
				)
				{
					value = '￥'+value;
				}
				
				newRow.push(value);
			});
			data.push(newRow);
		});
		
		const ws = XLSX.utils.aoa_to_sheet(data)
		// 设置每列的列宽，10代表10个字符，注意中文占2个字符
		/*
		ws['!cols'] = [
			{ wch: 10 },
			{ wch: 30 },
			{ wch: 25 }
		]
		*/
		/*
		ws['!images'] = [];
		ws['!images'].push({
			name:'image1.jpeg',
			data: picBlob,
			opts: {base64 : true},
			position:{
				type: 'twoCellAnchor',
				attrs: {editAs:'oneCell'},
				from: { col: 2, row : 2 },
				to: { col: 6, row: 5 }
			}
		});
		*/
		// 新建book
		const wb = XLSX.utils.book_new()
		// 生成xlsx文件(book,sheet数据,sheet命名)
		XLSX.utils.book_append_sheet(wb, ws, '数据详情')
		// 写文件(book,xlsx文件名称)
		let fileName = '商品订单导出列表'+formatTime('Y_m_d_H_i_s')+'.xlsx';
		XLSX.writeFile(wb, fileName);
		return;
	}
	
	/*
	export()
	{
		let selection = this.state.selectedRowKeys;
		let url = pcUrl('order','export');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['order_type'] = 1;
		let _next = ()=>{
			download(url,param)
				.then(()=>{
					
				});
		};
		if(!selection.length)
		{
			confirm('您没有选择要导出的数据，确认导出所有订单吗?')
				.then(()=>{
					_next();
				});
		}
		else
		{
			param['order_ids'] = selection.join(',');
			_next();
		}
	}
	*/
	
	add()
	{
		this.setState({
			'showDialog':true,
		});
	}
	
	show(index)
	{
		//获取订单详情
		let url = pcUrl('order','detail');
		let param = {
			'order_id':this.state.list[index]['order_id'],
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'info':data,
					'showDialog':true,
				});
			});
	}
	
	showPay(index)
	{
		let orderInfo = this.state.list[index];
		this.setState({
			'orderInfo':orderInfo,
			'showPayDialog':true,
		},()=>{
			this.payForm && this.payForm.setFieldsValue({
				'method':'alipay'
			});
		});
	}

	cancel(index)
	{
		confirm('确认要取消该订单吗?')
			.then(()=>{
				let url= pcUrl('order','cancel');
				let param = {
					'order_id':this.state.list[index]['order_id'],
				};
				httpPost(url,param)
					.then(()=>{
						message('订单取消成功','success');
						this.getList(this.state.pageInfo.current);
					});
			});
	}
	
	changeMethod(method)
	{
		if(this.loop)
			window.clearInterval(this.loop);
		
		if(method == 'wechatpay')
		{
			this.payForm.validateFields(['amount','method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											this.props.history.push('/user/success?out_trade_no='+paySn);
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else
		{
			this.payForm && this.payForm.setFieldsValue({'method':method});
		}
	}
	
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
				{
					document.write(data);
				}
				//余额支付，进入成功页
				else if(info.method == 'moneypay')
				{
					let paySn = data;
					this.props.history.push('/user/success?out_trade_no='+paySn);
				}
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('order','charge');
		let param = {
			'order_id':this.state.orderInfo['order_id'],
			'method': ['alipay','wechatpay','moneypay'].indexOf(info.method),
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	render()
	{
		return (
			<div>
				<div className="user-panel">
					<div className="captain">
						<h3>订单管理</h3>
					</div>
					<div className="panel-body">
						<div className="filter">
							<div className="float-right">
								<Button type="primary" onClick={()=>this.export()}>导出Excel</Button>
							</div>
							<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
								<Form.Item name="time">
									<DatePicker.RangePicker />
								</Form.Item>
								<Form.Item name="order_sn">
									<Input allowClear={true} style={{'width':'12em'}} placeholder="订单编号" />
								</Form.Item>
								<Form.Item name="order_status">
								<Select allowClear={true} style={{'width':'12em'}} placeholder="选择状态">
									{Object.keys(this.state.statusList).map(key=>(
									<Option value={key}>{this.state.statusList[key]}</Option>
									))}
								</Select>
								</Form.Item>
								<Form.Item name="">
									<Button htmlType="submit">搜索</Button>
								</Form.Item>
							</Form>
						</div>
						<Table
							rowSelection={{
								'selectedRowKeys':this.state.selectedRowKeys,
								'onChange':(selectedRowKeys, selectedRows)=>{this.setState({selectedRowKeys})},
							}}
							pagination={{...this.state.pageInfo,'onChange':(page)=>this.getList(page)}} dataSource={this.state.list}>
							<Column title="订单号" dataIndex="order_sn" />
							<Column title="商品数量" align="right" dataIndex="goods_count" />
							<Column title="订单金额" align="right" dataIndex="order_amount" />
							<Column title="订单状态" dataIndex="status" align="center" render={(text,row,index)=>this.state.statusList[row['order_status']]} />
							<Column title="生成时间" width={200} dataIndex="addTime" render={(text,row,index)=>parseTime(row.add_time)} />
							<Column title="操作" width={160} key="operate" render={(text,row,index)=>(
								<>
									<a href="javascript:;" className="text-blue" onClick={()=>this.show(index)}>订单详情</a>
									&nbsp;&nbsp;&nbsp;
									{row['order_status'] == 0 && +this.state.userInfo['is_manager'] ? (
										<Dropdown overlay={(
												<Menu>
													<Menu.Item onClick={()=>this.showPay(index)}>支付订单</Menu.Item>
													<Menu.Item onClick={()=>this.cancel(index)}>取消订单</Menu.Item>
												</Menu>
											)}>
											<a href="javascript:;" className="text-red">
												更多
												<span className="fa fa-angle-down"></span>
											</a>
										</Dropdown>
									):''}
								</>
							)} />
						</Table>
					</div>
				</div>
				
				<Modal
					title="订单信息"
					width={1000}
					visible={this.state.showDialog}
					footer={null}
					onOk={()=>this.submit()}
					onCancel={()=>this.setState({'showDialog':false})}
					>
					<div className="font-form">
						<Row gutter={16}>
							<Col span={12}>
								<Form
									labelCol={{ span:7 }}
									wrapperCol={{ span:18 }}
									ref={e=>this.mainForm = e}>
									<Form.Item label="订单编号">
										{this.state.info['order_sn']}
									</Form.Item>
									<Form.Item label="下单时间">
										{parseTime(this.state.info['add_time'])}
									</Form.Item>
									<Form.Item label="订单状态">
										{this.state.statusList[this.state.info['order_status']]}
									</Form.Item>
								</Form>
							</Col>
							<Col span={12}>
								<Form
									labelCol={{ span:7 }}
									wrapperCol={{ span:18 }}
									ref={e=>this.mainForm = e}>
									<Form.Item label="收货姓名">
										{this.state.info['extra_info']['reciver_consignee']}
									</Form.Item>
									<Form.Item label="联系电话">
										{this.state.info['extra_info']['reciver_phone']}
									</Form.Item>
									<Form.Item label="城市信息">
										{this.state.info['extra_info']['reciver_area_info']}
									</Form.Item>
									<Form.Item label="收货地址">
										{this.state.info['extra_info']['reciver_address']}
									</Form.Item>
								</Form>
							</Col>
							{/*
							<Col span={8}>
								<Form
									labelCol={{ span:7 }}
									wrapperCol={{ span:18 }}
									ref={e=>this.mainForm = e}>
									{this.state.info['extra_info']['order_category'].map(row=>(
										<Form.Item label={row['label']}>
											{row['exp']}
										</Form.Item>
									))}
								</Form>
							</Col>
							*/}
						</Row>
						<div class="height-10"></div>
						<Divider plain>商品信息</Divider>
						<div class="height-10"></div>
						<Table pagination={false} dataSource={this.state.info['goods_list']} scroll={{'x':true}}>
							<Column title="商品名称" ellipsis={true} width={100} dataIndex="goods_name" />
							<Column title="商品分类" ellipsis={true} width={100} dataIndex="category_name" />
							<Column title="缩略图" ellipsis={true} width={120} dataIndex="goods_thumb" render={(text,row,index)=>(
								<Image src={row['goods_thumb']['thumb_name']} preview={{src:row['goods_thumb']['image_name']}} height={80} />
							)} />
							
							<Column title="商品价格" ellipsis={true} width={100} dataIndex="goods_price" render={(text,row,index)=>'￥'+row['goods_price']} />
							<Column title="商品规格" ellipsis={true} width={100} dataIndex="goods_spec" />
							<Column title="数量" ellipsis={true} width={100} dataIndex="quantity" />
							<Column title="原价" ellipsis={true} width={100} dataIndex="goods_amount" />
							<Column title="应付金额" ellipsis={true} width={100} dataIndex="pay_amount" />
						</Table>
					</div>
				</Modal>
				
				<Modal
					title="支付订单"
					width={900}
					visible={this.state.showPayDialog}
					footer={null}
					onCancel={()=>this.setState({'showPayDialog':false})}
					>
					<div className="pay-head">
						<dl>
							<dt>
								应付金额：
								<span className="text-red"> ￥{this.state.orderInfo['order_amount']} </span>
							</dt>
							<dd>
								订单编号：{this.state.orderInfo['order_sn']}
							</dd>
							<dd>
								生成时间：{parseTime(this.state.orderInfo['add_time'])}
							</dd>
						</dl>
					</div>
					<div className="height-20"></div>
					<Form
						ref={e=>this.payForm = e}
						onFinish={(data)=>this.submit(data)}
						onFinishFailed={data=>this.focusError(data)}
						labelCol={{ span:3 }}
						wrapperCol={{ span:20 }}>
						<Form.Item name="method" label="充值方式">
							<Form.Item shouldUpdate>
								{()=>(
									<>
										<div className="pay-method">
											<ul>
												<li onClick={()=>this.changeMethod('alipay')}>
													<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'alipay'} value="alipay"></Radio>
													<img className="alipay-icon" src={require("@/assets/images/alipay.png")} />
												</li>
												<li onClick={()=>this.changeMethod('wechatpay')}>
													<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'wechatpay'} value="wechatpay"></Radio>
													<img className="wechatpay-icon" src={require("@/assets/images/wechatpay.jpg")} />
												</li>
												<li onClick={()=>this.changeMethod('moneypay')}>
													<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'moneypay'} value="moneypay"></Radio>
													<img className="wechatpay-icon" src={require("@/assets/images/money_pay.jpg")} />
												</li>
											</ul>
										</div>
										{this.payForm && this.payForm.getFieldValue('method') == 'wechatpay' && (
											<div className="pay-area">
												<div className="pay-area-left">
													<div className="pay-qr">
														{/*
														<img src={require("@/assets/images/wechat_qr.jpg")} />
														*/}
														<img src={this.state.wechatpay_qrcode} />
													</div>
													<div className="pay-attention">
														<dl>
															<dd className="float-left">
																<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
															</dd>
															<dt>
																请使用微信扫一扫
																<br/>
																扫描二维码以完成支付
															</dt>
														</dl>
													</div>
												</div>
												<div className="pay-area-right">
													<img src={require("@/assets/images/wechatpay_exp.jpg")} />
												</div>
											</div>
										)}
									</>
								)}
							</Form.Item>
						</Form.Item>
						{/*
						<Form.Item shouldUpdate label="营业执照">
							{()=>JSON.stringify(this.payForm && this.payForm.getFieldsValue())}
						</Form.Item>
						*/}
						<Form.Item shouldUpdate wrapperCol={{ offset:3,span:6 }}>
						{()=>this.payForm && this.payForm.getFieldValue('method') != 'wechatpay' && (
							<Button block type="primary" htmlType="submit" style={{'width':'18em','height':'36px'}}>确认</Button>
						)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		);
	}
}



